<template>
    <b-form-group
        :description="description"
        :invalid-feedback="invalidFeedback"
        :label-align="labelAlign"
        :label-class="labelFontWeight ? `font-weight-${labelFontWeight}` : ''"
        :label-cols="labelCols"
        :label="label"
        :state="state"
        :valid-feedback="validFeedback"
    >
        <template v-slot:description>
            <slot name="description" />
        </template>

        <template v-slot:invalid-feedback>
            <slot name="invalid-feedback" />
        </template>

        <template v-slot:label>
            <slot name="label" />
        </template>

        <template v-slot:valid-feedback>
            <slot name="valid-feedback" />
        </template>

        <slot />
    </b-form-group>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue'

export default {
    components: { BFormGroup },
    props: {
        description: { type: String },
        invalidFeedback: { type: String },
        label: { type: String },
        labelAlign: { type: String },
        labelCols: { type: [Boolean, Number, String] },
        labelFontWeight: { type: String },
        labelFor: { type: [Number, String] },
        state: { type: Boolean },
        validFeedback: { type: String },
    },
}
</script>